<template>
  <v-layout class="px-4 d-flex justify-center" wrap>
    <v-flex md12 class="pt-0">
      <MenuSettingTree
        ref="tree"
        :items="items"
        @onUpdateItems="onUpdateItems"
        @onEdit="editItem"
        @onRemove="removeItem"
      />
      <div v-if="!items.length" class="text-center">Chưa tồn tại bộ môn nào</div>
    </v-flex>
    <PopupAcademicLevel ref="popup-academic-level" />
  </v-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import BaseWrapper from '@/components/basic/BaseWrapper.vue'
import MenuSettingTree from './MenuSettingTree.vue'
import BaseButton from '@/components/basic/BaseButton.vue'
import PopupAcademicLevel from './PopupAcademicLevel.vue'
export default {
  components: {
    BaseWrapper,
    MenuSettingTree,
    BaseButton,
    PopupAcademicLevel,
  },
  props: {
    checkBoxs: Array,
    type: String,
  },
  data() {
    return {
      isDisplayMarketHeader: false,
      loading: true,
      dataType: [],
      isDisabled: false,
      items: [],
    }
  },
  computed: {
    ...mapState({
      academics: (state) => state.AcademicLevel.academics,
    }),
  },
  async created() {
    await this.fetchAcademicsWithChild()
  },
  methods: {
    ...mapActions({
      fetchAcademicsWithChild: 'AcademicLevel/fetchAcademicsWithChild',
      updateAcademicWithChildren: 'AcademicLevel/updateAcademicWithChildren',
      deleteAcademic: 'AcademicLevel/deleteAcademic',
    }),
    async updateAcademic() {
      try {
        this.$loading.active = true
        await this.updateAcademicWithChildren({ academics: this.items })
        // this.$alert.success('Chỉnh sửa thành công')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async onUpdateItems(items) {
      this.items = items
      await this.updateAcademic()
    },
    editItem(item) {
      this.$refs['popup-academic-level'].openDialog('edit', item)
    },
    removeItem(item) {
      this.$dialog.confirm({
        title: 'Xoá Bộ môn',
        text: 'Xoá chuyên nghành sẽ ảnh hưởng tới các dữ liệu khác, bạn có chắc chắn muốn xoá?',
        type: 'delete',
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.deleteAcademic(item.id)
            this.$alert.success('Xoá thành công')
            this.fetchAcademicsWithChild()
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },

  watch: {
    academics: {
      handler(val) {
        this.items = val
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.disable-setting {
  opacity: 0.8;
  pointer-events: none;
}
</style>
